<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetStranka" :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine" v-if="seznamVsehPrikljuckov.length > 0 && seznamOpreme.length > 0">
        <p class="open-sans-30pt" style="padding-bottom: 20px">
          Nastavitve mrežne opreme
        </p>
        <div class="odmik-izbire-mrezne-opreme">
          <p v-if="seznamVsehPrikljuckov.length > 1">
            <span>
              Izberite priključek
            </span>
            <IzbirnikPrikljuckaSelect
              style-class="izbirnik-label"
              @novIzbranPrikljucek="izbranPrikljucek = $event"
              :izbranPrikljucek="izbranPrikljucek"
              :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
            />
          </p>
        </div>
        <div v-loading="loadingOpremo">
          <div v-if="seznamOpreme.length > 0">
            <div>
              <div class="odmik-izbrane-opreme">
                <p>
                  <span>
                    Izberite opremo
                  </span>
                  <el-select v-model="idIzbranaOprema" placeholder="Oprema" class="odmik-izbrane-opreme">
                    <el-option v-for="(data) in seznamOpreme"
                               :value="data.id_oprema_prikljucek"
                               :label="data.oznaka + ' (' + data.serijska_st + ')'"
                               :key="data.id_oprema_prikljucek" />
                  </el-select>
                </p>
              </div>
            </div>
            <div class="odmik-tabov">
              <el-tabs type="border-card" value="t1" v-if="povezanoVOmrezje !== null && !loadingOpremo">
                <el-tab-pane label="Brezžično omrežje" name="t1" ref="t1">
                  <div>
                    <MultipleWifiNetworks
                      v-if="multipleWifiNetworksEquipmentEnum.includes(izbranaOpremaIdent)"
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                    <wifi
                      v-else
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane
                  label="Telefonija"
                  name="t3"
                  v-if="!multipleWifiNetworksEquipmentEnum.includes(izbranaOpremaIdent)">
                  <div>
                    <voip
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Posredovanje vrat" name="t4">
                  <div>
                    <portforward
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="DMZ" name="t5">
                  <div>
                    <dmz
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Rezervacija IP" name="t6">
                  <div>
                    <RezervacijaIp
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="vsebina-postavitev" v-else>
        <div class="odmik-vsebine">
          <p class="open-sans-30pt">
            Nastavitve mrežne opreme
          </p>
          <div>
            <div class="odmik-vsebine" style="padding-left: 0;">
              <div>
                <div class="postavitev-slike">
                  <img src="/static/img/Nastavitve/MreznaOprema/MojT2_Portal_Nastavitve_Onemogoceno.png" alt="">
                </div>
                <div class="postavitev-vsebine">
                  <p class="navadno-besedilo">
                    Na vašem uporabniškem računu nimate opreme, ki jo lahko upravljate na portalu Moj T-2.
                    <br/>
                    <br/>
                    Za več informacij nas lahko pokličete na številko {{kontaktniPodatki.T2_SUPPORT_TEL_ST}}
                    ali nam pišete na {{kontaktniPodatki.T2_INFO_EMAIL}}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import portforward from './tr069/Portforward.vue'
import wifi from './tr069/Wifi.vue'
import dmz from './tr069/Dmz.vue'
import voip from './tr069/Voip.vue'
import {Tabs, TabPane, Option, Select, Tooltip} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {KontaktniPodatkiEnum} from '../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import RezervacijaIp from './tr069/RezervacijaIp.vue'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import {MultipleWifiNetworksEquipmentEnum} from '../../../../assets/js/Enum/MultipleWifiNetworksEquipmentEnum'
import MultipleWifiNetworks from './tr069/MultipleWifiNetworks.vue'

export default {
  name: 'NastavitveMreznaOprema',
  data () {
    return {
      title: 'Nastavitve mrežne opreme',
      clientAgent: null,
      izbranPrikljucek: '',
      seznamOpreme: [],
      idIzbranaOprema: '',
      loadingOpremo: true,
      kontaktniPodatki: '',
      seznamNosilnihPrikljuckov: [],
      pridobivanjePodatkov: true,
      izbranaStranka: null,
      selectorPermissions: ['STRANKE'],
      povezanoVOmrezje: null,
      seznamPrikljuckovGrupirano: [],
      seznamVsehPrikljuckov: [],
      loadingConnectedDevice: null,
      izbranaOpremaIdent: null,
      multipleWifiNetworksEquipmentEnum: MultipleWifiNetworksEquipmentEnum
    }
  },
  components: {
    MultipleWifiNetworks,
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    'RezervacijaIp': RezervacijaIp,
    'portforward': portforward,
    'wifi': wifi,
    'dmz': dmz,
    'voip': voip,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip
  },
  watch: {
    izbranPrikljucek: function (val) {
      if (this.val !== '') {
        this.GetSeznamOpreme(val)
      }
    },
    idIzbranaOprema: function (val) {
      if (this.val !== '') {
        this.GetConnectedInfo(val)
        this.seznamOpreme.forEach(oprema => {
          if (oprema.id_oprema_prikljucek === val) {
            this.izbranaOpremaIdent = oprema.ident
          }
        })
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.kontaktniPodatki = KontaktniPodatkiEnum
  },
  methods: {
    GetConnectedInfo (prenosniParamIdOprema) {
      if (prenosniParamIdOprema !== '') {
        this.loadingOpremo = true
        let param = ['idOprema=' + this.idIzbranaOprema]
        this.clientAgent.postWsRequest(
          this,
          'tr069/wan/info',
          param,
          null,
          'SetConnectedInfo',
          'ErrConnectedInfo')
      }
    },

    SetConnectedInfo (podatki) {
      this.povezanoVOmrezje = podatki.data.length !== 0
      this.loadingOpremo = false
    },
    ErrConnectedInfo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja(podatkiStranke)
      }
    },
    GetSeznamOpreme (izbranPrikljucek) {
      if (izbranPrikljucek !== '') {
        this.loadingOpremo = true
        this.seznamOpreme = []
        this.idIzbranaOprema = ''
        this.izbranaOpremaIdent = null
        let param = ['filter[id_prikljucek]=' + this.izbranPrikljucek]
        param.push('permissionId=TR_OPREMA')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetSeznamOpreme',
          'ErrSeznamOpreme')
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissionId=PRIKLJUCKI']
        param.push('filter[tip_prikljucka]=FIX')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamVsehPrikljuckov = []
      this.seznamPrikljuckovGrupirano = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.permission.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      this.pridobivanjePodatkov = false
    },
    ErrPrikljuckiDovoljenja (podatki) {
      this.ShowWarningMessage(podatki)
    },
    SetSeznamOpreme (podatki) {
      this.seznamOpreme = podatki.permission.additionalData
      if (this.seznamOpreme.length > 0) {
        for (let i = 0; i < this.seznamOpreme.length; i++) {
          if (typeof this.seznamOpreme[i].id_oprema_prikljucek !== 'undefined') {
            this.idIzbranaOprema = this.seznamOpreme[0].id_oprema_prikljucek
            this.izbranaOpremaIdent = this.seznamOpreme[0].ident
          }
        }
      }
    },
    ErrSeznamOpreme (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.loadingOpremo = false
    },
    SuccessNotification () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Podatki so bili uspešno posodobljeni. Osvežen prikaz bo na voljo v nekaj minutah.'
      this.ShowSuccessMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="./../../../../../static/css/Nastavitve/MreznaOprema/MreznaOprema.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveMreznaOprema.vue